import React from 'react'
import logo from '../logo/logo.png'
export default function HEADER() {
    return (
        <>
            {/* Love and a red rose can’t be hid. */}
            <div className='header'>
                <div className='logo'><img src={logo} alt='LOGO'></img></div>
               
            </div>
        </>
    )
}

